import { createApp } from "vue";
import AccountManagement from "../../components/AccountManagement.vue";
import i18n from "../translations/i18n";

export const initializeMyAccountApp = () => {
    if (!document.getElementById('js_myAccount')) {
        return;
    }

    createApp({
        components: { AccountManagement }
    })
        .use(i18n)
        .mount('#js_myAccount');
};